import { useAlgoliaAppContext } from './useAlgoliaAppContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const forms = document.querySelectorAll('search-form-component');
export const useSearchForm = () => {
    const { pagePath } = useAlgoliaAppContext();
    const navigate = useNavigate();
    const handler = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.input === null)
            return;
        navigate({
            pathname: '/search',
            search: form.input.value.length > 0 ? `?q=${form.input?.value}` : undefined
        });
        if (form.loading !== undefined)
            form.loading = false;
        form.btn?.focus();
        form.hide?.();
    };
    useEffect(() => {
        if (pagePath !== 'search' || forms.length < 1)
            return;
        forms.forEach(form => {
            form.addEventListener('submit', handler);
        });
        return () => {
            forms.forEach(form => {
                form.removeEventListener('submit', handler);
            });
        };
    }, []);
};
